export default __webpack_public_path__ + "static/media/group-211@2x.1ef51d82.png";